import React from 'react';
import { Skeleton } from './Skeleton';

interface LeaderboardSkeletonProps {
  rows?: number;
}

export const LeaderboardSkeleton: React.FC<LeaderboardSkeletonProps> = ({ rows = 10 }) => {
  return (
    <div className="space-y-0">
      {Array.from({ length: rows }).map((_, index) => (
        <div
          key={index}
          className="grid grid-cols-12 items-center gap-2 border-b border-white/10 px-4 py-3"
        >
          {/* Rank */}
          <div className="col-span-1 flex justify-center">
            <Skeleton variant="circular" className="h-6 w-6" />
          </div>

          {/* Player */}
          <div className="col-span-4 flex items-center gap-2">
            <Skeleton variant="circular" className="h-8 w-8" />
            <div className="space-y-1">
              <Skeleton variant="text" className="h-4 w-20" />
              <Skeleton variant="text" className="h-3 w-16" />
            </div>
          </div>

          {/* Rank Tier */}
          <div className="col-span-2 flex justify-center">
            <Skeleton variant="rectangular" className="h-6 w-16 rounded" />
          </div>

          {/* Main Stat */}
          <div className="col-span-2 flex justify-center">
            <Skeleton variant="text" className="h-6 w-12" />
          </div>

          {/* W/L */}
          <div className="col-span-1 flex justify-center">
            <Skeleton variant="text" className="h-4 w-10" />
          </div>

          {/* Last Active */}
          <div className="col-span-2 flex justify-center">
            <Skeleton variant="text" className="h-4 w-16" />
          </div>
        </div>
      ))}
    </div>
  );
};
